import Vue from 'vue'
import Axios from 'axios'
import $user from '../services/user'
import $notify from '../services/notification'
import $router from '../router'
import $appCode from '../services/app-code'
import $message from '../services/message'

var axios = Axios.create({
  baseURL: SERVER_URL
})

var api = {
  setHeadersAccessToken(accessToken) {
    if (accessToken) {
      axios.defaults.headers.common['accessToken'] = accessToken
    }
  },

  // after-entering-survey
  checkTokenClientSurvey(token){
    return axios.get('/one-time-url/checkTokenClientSurvey?token=' + token,{
    })
  },

  getAgreement(token) {
    return axios.get('/after-entering-survey/getAgreement?token=' + token, {
    })
  },

  postClientSurvey(data){
    return axios.post('/after-entering-survey/postClientSurvey', {
        'agreementDto': data.agreement,
        'token': data.token,
        'answer1': data.question1,
        'answer2': data.question2,
        'answer3_1': data.question3_1,
        'answer3_2': data.question3_2,
        'answer3_3': data.question3_3,
        'answer3_4': data.question3_4,
        'answer4': data.question4,
        'answerer': data.name
    })
  },

  // nps
  getCsAndRecruitOcup() {
    return axios.get('/master/getCsAndRecruitOcup')
  },

  getCsAndRecruitAgent() {
    return axios.get('/master/getCsAndRecruitAgent')
  },

  checkTokenCSAndRecruit(token){
    return axios.get('/one-time-url/checkTokenCSAndRecruit?token=' + token,{
    })
  },

  postCSAndRecruit(data){
    return axios.post('/csandrecruit/postCSAndRecruit', {
        'token': data.token,
        'csAndRecruitId': data.csAndRecruitId,
        'clientId': data.clientId,
        'answerer': data.name,
        'answer1': data.question1,
        'answer2': data.question2,
        'answer3': data.question3,
        'answer4': data.question4,
        'answer5': data.question5,
        'answer5Other': data.question5_other,
        'answer6Ocup1': data.question6_ocup1,
        'answer6EmploymentPlan1': data.question6_employmentPlan1,
        'answer6Ocup2': data.question6_ocup2,
        'answer6EmploymentPlan2': data.question6_employmentPlan2,
        'answer6Ocup3': data.question6_ocup3,
        'answer6EmploymentPlan3': data.question6_employmentPlan3,
        'answer6Ocup4': data.question6_ocup4,
        'answer6EmploymentPlan4': data.question6_employmentPlan4,
        'answer6Ocup5': data.question6_ocup5,
        'answer6EmploymentPlan5': data.question6_employmentPlan5,
        'answer7': data.question7,
        'answer6Progress': data.question6_progress,
        'answerAgent': data.questionAgent,
        'answerAgentOther': data.questionAgentOther,
        'answer6Other': data.question6Other,
        'answerHighClassNeeds': data.questionHighClassNeeds,
        'answerHighClassNeedsOther': data.questionHighClassNeedsOther,
        'answererPost': data.post,
        'answer8RecruitmentNum': data.question8_recruitment_staff,
        'answer8AssistantNum': data.question8_recruitment_assistant
      })
  },

  getCareerMailEntryStatus(token) {
    return axios.get('/career-mail/entry-status/?token=' + token)
  },
  postCareerMail(token) {
    return axios.post('/career-mail/', {
      token: token
    })
  },

  getRetirement(token) {
    return axios.get('/retirement/?token=' + token)
  },

  postRetirement(data) {
    return axios.post('/retirement/', {
      histAgrId: data.agreement_cancel.maxHistAgrId
      , clientAgreement: data.agreement
      , clientComment: data.clientComment
      , confirmer: data.confirmer
      , token: data.token
      , careerName: data.agreement_cancel.lastName + " " + data.agreement_cancel.firstName
      , entDate: data.agreement_cancel.entDate
      , resignationDate: data.agreement_cancel.resignationDate
      , rtnper: data.agreement_cancel.rtnper
      , rtnmoney: data.agreement_cancel.rtnmoney
      , rtnmoneytaxincluded: data.agreement_cancel.rtnmoneytaxincluded
      , rtnTransferDate: data.agreement_cancel.rtnTransferDate
      , rtnBankName: data.agreement_cancel.rtnBankName
      , rtnBranchName: data.agreement_cancel.rtnBranchName
      , rtnAccountNo: data.agreement_cancel.rtnAccountNo
      , rtnAccountName: data.agreement_cancel.rtnAccountName
    })
  },

  getOrderConfirm(token) {
    return axios.get('/order-confirm/?token=' + token);
  },

  getOrderConfirmList(token) {
    return axios.get('/order-confirm/list?token=' + token);
  },

  downloadOrderFile(token, orderId) {
    return axios.get('/order-confirm/download/' + orderId + '?token=' + token, {
      responseType: 'blob'
    });
  },

  postOpenOrder(data, orderId, requestDate) {
    return axios.post('/order-confirm/open', {
      'token': data.token,
      'orderId': orderId,
      'requestDate': requestDate,
      'lastName': data.lastName,
      'firstName': data.firstName,
      'projectScaleValues': data.projectScaleValues
    });
  },

  postFixOrder(data, orderId, requestDate) {
    return axios.post('/order-confirm/fix', {
      'token': data.token,
      'orderId': orderId,
      'requestDate': requestDate,
      'comment': data.comment,
      'lastName': data.lastName,
      'firstName': data.firstName
    }) ;
  },

  checkScheduleToken(token) {
    return axios.get('/schedule/check-token?token=' + token)
  },

  postSchedule(data) {
    return axios.post('/schedule', {
      token: data.token
      , requiredMinutes: data.requiredMinutes
      , interviewDate: data.selectedDate + ' ' + data.selectedTime.timeString
      , interviewType: data.interviewType
      , interviewerName: data.interviewerName
      , interviewDetail: data.interviewDetail
    })
  },

  postReschedule(token, requiredMinutes, hopeDates) {
    return axios.post('/schedule/reschedule', {
      token: token
      , requiredMinutes: requiredMinutes
      , hopeDates: hopeDates
    })
  },
  
  // Read config file
  getConfig(next) {
    var privateAxios = Axios.create()
    privateAxios.get('/static/config.json?t=202605031500')
      .then((res) => {
        if (next) {
          if (typeof res.data !== 'object') {
            res.data = JSON.parse(res.data)
          }
          next(res.data)
        }
      })
      .catch((error) => {
        $notify.error(undefined, $message.config['error'])
      })
  },
}

/**
 * Handle loading
 */
var countCalledAPI = 0
var loading = $('#loading')

function increaseCalledAPI(config) {
  if (config && config.method === 'post' && countCalledAPI++ === 0) {
    loading.fadeIn(0)
  }
}

function decreaseCalledAPI(config) {
  if (config && config.method === 'post' && --countCalledAPI < 1) {
    loading.fadeOut(500)
    countCalledAPI = 0
  }
}

// Request interceptor
axios.interceptors.request.use(function (config) {
  increaseCalledAPI(config)
  return config
}, function (error) {
  decreaseCalledAPI(error.config)
  $appCode.message = ''
  return Promise.reject(error)
})

// Response interceptor
axios.interceptors.response.use(function (response) {
  decreaseCalledAPI(response.config)
  $appCode.message = ''
  if (!response.data) {
    $router.replace('/page-not-found')
  }
  return response;
}, function (error) {
  decreaseCalledAPI(error.config)
  $appCode.message = ''
  if (error.response) {
    // Handle 401 & 403 error
    if (error.response.status === 401 || error.response.status === 403) {
      api.cleanDataToLogin()
    }
    // Handle 500 & null of response data error
    else if (error.response.status === 500 || !error.response.data) {
      $notify.error(undefined, $message.status['500'])
    }
    // Handle 503 error
    else if (error.response.status === 503) {
      $router.replace('/maintenance')
    }
    // Handle 404 error    
    else if (error.response.status === 404) {
      $router.replace('/page-not-found')
    }
    // Handle other error 
    else if (error.response.status !== 400) {
      $notify.error((error.response.data.status || '不明な') + 'エラー', error.response.data.error || '')
    }
    // Handle 400 error
    else {
      var appCode = $appCode[error.response.data.appCode]
      if (appCode) {
        // show message immediately
        if (appCode.type === 0) {
          $notify.error(undefined, appCode.value)
        }
        else if (appCode.type === 1) {
          $appCode.message = appCode.value
        }
        // handle later
        else {
          appCode.name = error.response.data.appCode
          error.appCode = appCode
        }
      } else {
        $notify.error($message.status['unknown'], error.response.data.appCode)
      }
    }
  } else if (error.request) {
    $notify.error('Error', '通信エラーが発生しています。')
  } else {
    $notify.error('Error', 'サーバーエラーが発生しています。')
  }
  return Promise.reject(error);
});

Vue.use({
  install(Vue, options) {
    api.setHeadersAccessToken($user.getAccessToken())

    Vue.prototype['$api'] = api
  }
})

export default api



// WEBPACK FOOTER //
// ./src/services/axios.js